'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import { getIsLayoutBuilderVisible } from 'LayoutBuilderUI/selectors/appStatus';
import { withPanelErrorBoundary } from 'EmailEditorUI/hoc/withErrorBoundary';
import { getSelectedType } from 'EmailEditorUI/redux/selectors/selected';
import { NamespaceWrapper } from 'EmailEditorUI/components/NamespaceWrapper';
import InpageSidebarPortal from 'ContentEditorUI/components/portals/InpageSidebarPortal';
import { INPAGE_SIDEBAR_IFRAME_WINDOW_NAME } from 'ContentEditorUI/lib/app/constants';
import { EVENT_ADD_WINDOW_TO_REACT_DND } from 'ContentEditorUI/lib/inpage/Constants';
import ContentPanel from 'LayoutBuilderUI/components/panels/Content';
import { reportLBUIReady } from 'LayoutBuilderUI/actions/ApiActions';
import { waitForSidebarIframeLoaded } from 'LayoutBuilderUI/actions/CrossFrameActions';
import { getIsTrellisTheme } from 'EmailEditorUI/redux/selectors/appStatusSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
class PortaledSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarIframeLoadedAndReactDndSetup: false
    };
    this.onSidebarIframeLoaded = () => {
      const inpageIframeWindow = window;
      inpageIframeWindow.postMessage({
        type: EVENT_ADD_WINDOW_TO_REACT_DND,
        windowName: INPAGE_SIDEBAR_IFRAME_WINDOW_NAME
      }, '*');
      reportLBUIReady();
      this.setState({
        sidebarIframeLoadedAndReactDndSetup: true
      });
    };
    const _inpageIframeWindow = window;
    this.sidebarIframeWindow = _inpageIframeWindow.parent.frames[INPAGE_SIDEBAR_IFRAME_WINDOW_NAME].window;
  }
  componentDidMount() {
    this.checkIfSidebarIframeIsLoaded();
  }
  componentDidUpdate(prevProps) {
    const {
      isLayoutBuilderVisible
    } = this.props;
    if (isLayoutBuilderVisible !== prevProps.isLayoutBuilderVisible) {
      this.checkIfSidebarIframeIsLoaded();
    }
  }
  checkIfSidebarIframeIsLoaded() {
    const {
      isLayoutBuilderVisible
    } = this.props;
    if (!isLayoutBuilderVisible || this.state.sidebarIframeLoadedAndReactDndSetup) {
      return;
    }
    try {
      if (this.sidebarIframeWindow.document.readyState === 'complete') {
        this.onSidebarIframeLoaded();
      } else {
        this.sidebarIframeWindow.addEventListener('load', this.onSidebarIframeLoaded, {
          once: true
        });
      }
    } catch (e) {
      waitForSidebarIframeLoaded(this.onSidebarIframeLoaded);
    }
  }
  render() {
    if (!this.state.sidebarIframeLoadedAndReactDndSetup || !this.props.isLayoutBuilderVisible) {
      return null;
    }
    return /*#__PURE__*/_jsx(InpageSidebarPortal, {
      sidebarIframeWindow: this.sidebarIframeWindow,
      isTrellisTheme: this.props.isTrellisTheme,
      children: /*#__PURE__*/_jsx(NamespaceWrapper, {
        use: "div",
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(ContentPanel, {})
        })
      })
    });
  }
}
const mapStateToProps = state => ({
  isLayoutBuilderVisible: getIsLayoutBuilderVisible(state),
  selectedType: getSelectedType(state),
  isTrellisTheme: getIsTrellisTheme(state)
});
export default withPanelErrorBoundary(connect(mapStateToProps)(PortaledSidebar));